module.exports = __webpack_public_path__ + "static/media/why-chart-mobile1.7cdeb06b.png";